
(function(){
  var root = document.getElementById('kje-root');
  if(!root) return;

  /* -------------------- icones (memes traces que " Mon espace ") -------------------- */
  var ICONES = {
    quiz: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9.2 9.1a2.9 2.9 0 1 1 3.6 2.8c-.8.2-1.3.9-1.3 1.7v.6"/><circle cx="11.5" cy="18" r="1.1" fill="currentColor" stroke="none"/><rect x="3" y="3" width="18" height="18" rx="4.5"/></svg>',
    grille: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3.2" y="3.2" width="17.6" height="17.6" rx="3"/><path d="M9.1 3.2v17.6M14.9 3.2v17.6M3.2 9.1h17.6M3.2 14.9h17.6"/></svg>',
    loupe: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.6" cy="10.6" r="6.4"/><path d="M15.3 15.3 20.5 20.5"/><path d="M8.2 10.6h4.8"/></svg>',
    maison: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 10.4 12 4l8 6.4V19a1.6 1.6 0 0 1-1.6 1.6H5.6A1.6 1.6 0 0 1 4 19Z"/><path d="M9.6 20.6v-6h4.8v6"/></svg>',
    etoile: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.6c.9 4.2 2.6 5.9 6.8 6.8-4.2.9-5.9 2.6-6.8 6.8-.9-4.2-2.6-5.9-6.8-6.8 4.2-.9 5.9-2.6 6.8-6.8Z"/></svg>',
    fleche: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13M12.5 6l6 6-6 6"/></svg>',
    croix: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ============================================================
     LES JEUX DEJA PRESENTS SUR LA PAGE
     On ne recopie rien : on retrouve chaque jeu par son identifiant,
     on masque la section qui le contient, et on le deplacera dans la
     pop-up au moment du clic.
     ============================================================ */
  function reperer(bulle){
    var el = document.querySelector(bulle.jeu);
    if(!el) return null;
    // Deux cas de figure :
    //  - version en section de theme : le jeu est range dans une reserve
    //    [data-kje-reserve] a l'interieur de CETTE section ;
    //  - version \u00ab HTML personnalis\u00e9 \u00bb : le jeu est dans sa propre section
    //    Shopify, plus bas sur la page.
    // Masquer la mauvaise, ce serait masquer les bulles elles-memes.
    var hote = el.closest('[data-kje-reserve]') || el.closest('.shopify-section') || el;
    var repere = document.createComment('jeu ' + bulle.jeu);
    el.parentNode.insertBefore(repere, el);
    hote.style.display = 'none';
    return { el: el, hote: hote, repere: repere };
  }

  /* ============================================================
     LA POP-UP
     ============================================================ */
  var modalEl, panneauEl, sceneEl, surEl, titreEl, declencheur = null, jeuOuvert = null, scrollY = 0;

  function construireModal(r){
    modalEl = document.createElement('div');
    modalEl.className = 'kje-modal';
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.innerHTML =
      '<div class="kje-fond" data-kje-fermer></div>' +
      '<div class="kje-hote">' +
        '<div class="kje-panneau" role="dialog" aria-modal="true" aria-labelledby="kje-modal-titre" tabindex="-1">' +
          '<header class="kje-tete">' +
            '<span class="kje-tete-textes">' +
              '<span class="kje-tete-sur" data-kje-sur></span>' +
              '<span class="kje-tete-titre" id="kje-modal-titre" data-kje-titre-modal></span>' +
            '</span>' +
            '<button type="button" class="kje-croix" data-kje-fermer aria-label="' +
              esc(r.FERMER_ARIA || 'Fermer le jeu') + '">' + ICONES.croix + '</button>' +
          '</header>' +
          '<div class="kje-scene" data-kje-scene></div>' +
          '<div class="kje-pied">' +
            '<button type="button" class="kje-fermer-texte" data-kje-fermer>' +
              esc(r.FERMER || 'Fermer') + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modalEl);
    panneauEl = modalEl.querySelector('.kje-panneau');
    sceneEl = modalEl.querySelector('[data-kje-scene]');
    surEl = modalEl.querySelector('[data-kje-sur]');
    titreEl = modalEl.querySelector('[data-kje-titre-modal]');

    panneauEl.addEventListener('click', function(e){ e.stopPropagation(); });
    [].slice.call(modalEl.querySelectorAll('[data-kje-fermer]')).forEach(function(el){
      el.addEventListener('click', fermer);
    });
    modalEl.addEventListener('keydown', auClavier);
  }

  function auClavier(e){
    if(e.key === 'Escape' || e.key === 'Esc'){ fermer(); return; }
    if(e.key !== 'Tab') return;
    // Piege a focus : la tabulation tourne en rond dans la pop-up.
    var cibles = [].slice.call(panneauEl.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function(el){ return el.offsetParent !== null; });
    if(!cibles.length) return;
    var premier = cibles[0], dernier = cibles[cibles.length - 1];
    if(e.shiftKey && document.activeElement === premier){ e.preventDefault(); dernier.focus(); }
    else if(!e.shiftKey && document.activeElement === dernier){ e.preventDefault(); premier.focus(); }
  }

  function ouvrir(bulle, btn, r){
    if(!modalEl) construireModal(r);
    if(!bulle.ref) return;
    declencheur = btn || null;
    jeuOuvert = bulle;

    surEl.textContent = bulle.sur || r.SUR_DEFAUT || 'Les jeux Koehler';
    titreEl.textContent = bulle.titreModal || bulle.libelle;

    // Le jeu quitte sa section masquee pour venir dans la pop-up. Il garde
    // son etat : une grille commencee se retrouve telle quelle.
    sceneEl.appendChild(bulle.ref.el);

    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var barre = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.position = 'fixed';
    document.body.style.top = (-scrollY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    if(barre > 0) document.body.style.paddingRight = barre + 'px';

    modalEl.classList.add('kje-ouvert');
    modalEl.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){ modalEl.classList.add('kje-anim'); });
    });
    panneauEl.focus();
    sceneEl.scrollTop = 0;
  }

  function fermer(){
    if(!modalEl || !modalEl.classList.contains('kje-ouvert')) return;
    modalEl.classList.remove('kje-anim');

    var fini = false;
    var terminer = function(){
      if(fini) return;
      fini = true;
      modalEl.classList.remove('kje-ouvert');
      modalEl.setAttribute('aria-hidden', 'true');

      // Le jeu retourne exactement a sa place, dans sa section masquee.
      if(jeuOuvert && jeuOuvert.ref){
        var ref = jeuOuvert.ref;
        ref.repere.parentNode.insertBefore(ref.el, ref.repere);
      }
      jeuOuvert = null;

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
      window.scrollTo(0, scrollY);

      if(declencheur){ declencheur.focus(); declencheur = null; }
    };
    setTimeout(terminer, 320);
  }

  /* ============================================================
     LES BULLES \u2014 meme construction que \u00ab Mon espace Koehler \u00bb
     ============================================================ */
  function construireBulles(r, bulles){
    var hote = root.querySelector('[data-kje-bulles]');
    hote.setAttribute('aria-label', r.TITRE || 'Les jeux Koehler');
    hote.style.setProperty('--kje-cols', Math.min(bulles.length || 1, 4));

    hote.innerHTML = bulles.map(function(b){
      var interieur =
        '<span class="kje-ico" aria-hidden="true">' + (ICONES[b.icone] || ICONES.etoile) + '</span>' +
        '<span class="kje-textes">' +
          '<span class="kje-libelle">' + esc(b.libelle) + '</span>' +
          '<span class="kje-sous">' + esc(b.sous || '') + '</span>' +
        '</span>' +
        '<span class="kje-fleche" aria-hidden="true">' + ICONES.fleche + '</span>';

      if(b.jeu){
        return '<button type="button" class="kje-bulle" data-kje-jeu="' + esc(b.jeu) + '" ' +
                 'aria-haspopup="dialog">' + interieur + '</button>';
      }
      var cible = b.nouvelOnglet ? ' target="_blank" rel="noopener"' : '';
      return '<a class="kje-bulle" href="' + esc(b.lien || '#') + '"' + cible + '>' + interieur + '</a>';
    }).join('');

    bulles.forEach(function(b){
      if(!b.jeu) return;
      var btn = hote.querySelector('[data-kje-jeu="' + b.jeu + '"]');
      if(btn) btn.addEventListener('click', function(){ ouvrir(b, btn, r); });
    });
  }

  /* ============================================================
     DEMARRAGE
     Les jeux sont colles PLUS BAS sur la page : on attend donc que
     le document soit lu avant d'aller les chercher.
     ============================================================ */
  function demarrer(r){
    var bulles = (r.BULLES || []).filter(function(b){ return b && b.libelle; });

    bulles.forEach(function(b){
      if(!b.jeu) return;
      b.ref = reperer(b);
      if(!b.ref && window.console && console.warn){
        console.warn('[Koehler] Jeu introuvable sur la page : ' + b.jeu +
                     ' \u2014 la bulle \u00ab ' + b.libelle + ' \u00bb est masqu\u00e9e.');
      }
    });
    bulles = bulles.filter(function(b){ return !b.jeu || b.ref; });
    if(!bulles.length) return;

    var head = root.querySelector('[data-kje-head]');
    root.querySelector('[data-kje-kicker]').textContent = r.ACCROCHE || '';
    root.querySelector('[data-kje-titre]').textContent = r.TITRE || '';
    root.querySelector('[data-kje-chapo]').textContent = r.CHAPO || '';
    head.hidden = !(r.ACCROCHE || r.TITRE || r.CHAPO);

    construireBulles(r, bulles);
  }

  function quandPret(fn){
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  if(window.KJE_REGLAGES){ quandPret(function(){ demarrer(window.KJE_REGLAGES); }); }
  else {
    document.addEventListener('kje:reglages-prets', function(){
      quandPret(function(){ demarrer(window.KJE_REGLAGES); });
    });
  }
})();


(function(){
  var root = document.getElementById('kqv-root');
  if(!root) return;

  var ICONES = {
    juste: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12.6 9.5 17.5 19.5 6.5"/></svg>',
    rate: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    fleche: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13M12.5 6l6 6-6 6"/></svg>',
    reprise: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 1 1-2.6-5.9"/><path d="M20 4.5V10h-5.5"/></svg>'
  };

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var carte = root.querySelector('[data-kqv-carte]');
  var reglages, questions, index = 0, score = 0, repondu = false;

  /* ---------------- la carte, une question ---------------- */
  function afficherQuestion(){
    var q = questions[index];
    repondu = false;

    carte.innerHTML =
      '<div class="kqv-tete">' +
        '<p class="kqv-etiquette">' + esc(reglages.ETIQUETTE || 'Vrai ou faux') + '</p>' +
        '<p class="kqv-compteur">' + (index + 1) + ' / ' + questions.length + '</p>' +
      '</div>' +
      '<div class="kqv-jauge" role="presentation"><span data-kqv-jauge></span></div>' +
      '<div class="kqv-scene kqv-anim">' +
        '<p class="kqv-affirmation">' + esc(q.a) + '</p>' +
        '<div class="kqv-choix">' +
          '<button type="button" class="kqv-bouton" data-kqv-rep="1">' +
            esc(reglages.VRAI || 'Vrai') + '</button>' +
          '<button type="button" class="kqv-bouton" data-kqv-rep="0">' +
            esc(reglages.FAUX || 'Faux') + '</button>' +
        '</div>' +
        '<div data-kqv-zone aria-live="polite"></div>' +
      '</div>';

    // La jauge part de la largeur precedente pour que la transition se voie.
    var jauge = carte.querySelector('[data-kqv-jauge]');
    jauge.style.width = (index / questions.length * 100) + '%';
    requestAnimationFrame(function(){
      jauge.style.width = ((index + 1) / questions.length * 100) + '%';
    });

    [].slice.call(carte.querySelectorAll('[data-kqv-rep]')).forEach(function(btn){
      btn.addEventListener('click', function(){
        repondre(btn.getAttribute('data-kqv-rep') === '1', btn);
      });
    });
  }

  /* ---------------- la reponse ---------------- */
  function repondre(choix, btn){
    if(repondu) return;
    repondu = true;

    var q = questions[index];
    var juste = (choix === !!q.r);
    if(juste) score++;

    var boutons = [].slice.call(carte.querySelectorAll('[data-kqv-rep]'));
    boutons.forEach(function(b){
      var estVrai = b.getAttribute('data-kqv-rep') === '1';
      b.disabled = true;
      if(estVrai === !!q.r) b.classList.add('kqv-juste');
      else if(b === btn) b.classList.add('kqv-faux-choix');
      else b.classList.add('kqv-eteint');
    });

    var bonneLabel = q.r ? (reglages.VRAI || 'Vrai') : (reglages.FAUX || 'Faux');
    var titre = juste
      ? (reglages.BRAVO || 'Bonne r\u00e9ponse')
      : (reglages.RATE || 'Rat\u00e9') + ' \u2014 ' + (reglages.CETAIT || 'la r\u00e9ponse \u00e9tait') + ' ' + bonneLabel;

    var dernier = (index === questions.length - 1);
    var zone = carte.querySelector('[data-kqv-zone]');
    zone.innerHTML =
      '<div class="kqv-reponse kqv-anim">' +
        '<p class="kqv-verdict' + (juste ? '' : ' kqv-rate') + '">' +
          (juste ? ICONES.juste : ICONES.rate) + '<span>' + esc(titre) + '</span></p>' +
        '<p class="kqv-explication">' + esc(q.e || '') + '</p>' +
      '</div>' +
      '<div class="kqv-pied">' +
        '<button type="button" class="kqv-suivant" data-kqv-suivant>' +
          esc(dernier ? (reglages.VOIR_RESULTAT || 'Voir mon r\u00e9sultat')
                      : (reglages.SUIVANT || 'Question suivante')) +
          ICONES.fleche +
        '</button>' +
      '</div>';

    var suivant = zone.querySelector('[data-kqv-suivant]');
    suivant.addEventListener('click', function(){
      if(dernier){ afficherResultat(); }
      else { index++; afficherQuestion(); recadrer(); }
    });
    suivant.focus({ preventScroll: true });
  }

  /* ---------------- l'ecran final ---------------- */
  function afficherResultat(){
    var paliers = (reglages.PALIERS || []).slice().sort(function(a, b){ return b.min - a.min; });
    var palier = null;
    for(var i = 0; i < paliers.length; i++){
      if(score >= paliers[i].min){ palier = paliers[i]; break; }
    }
    palier = palier || { titre: '', texte: '' };

    var rdv = reglages.RDV || {};
    carte.innerHTML =
      '<div class="kqv-tete">' +
        '<p class="kqv-etiquette">' + esc(reglages.ETIQUETTE_FIN || 'Votre r\u00e9sultat') + '</p>' +
        '<p class="kqv-compteur">' + questions.length + ' / ' + questions.length + '</p>' +
      '</div>' +
      '<div class="kqv-jauge" role="presentation"><span style="width:100%"></span></div>' +
      '<div class="kqv-final kqv-anim">' +
        '<p class="kqv-score">' + score + ' <small>/ ' + questions.length + '</small></p>' +
        '<div class="kqv-filet" aria-hidden="true"></div>' +
        '<h3 class="kqv-final-titre">' + esc(palier.titre || '') + '</h3>' +
        '<p class="kqv-final-texte">' + esc(palier.texte || '') + '</p>' +
        '<div class="kqv-final-actions">' +
          '<button type="button" class="kqv-rejouer" data-kqv-rejouer>' +
            ICONES.reprise + esc(reglages.REJOUER || 'Recommencer') + '</button>' +
          (rdv.lien
            ? '<a class="kqv-suivant" href="' + esc(rdv.lien) + '"' +
              (rdv.nouvelOnglet ? ' target="_blank" rel="noopener"' : '') + '>' +
                esc(rdv.libelle || 'Prendre rendez-vous') + ICONES.fleche + '</a>'
            : '') +
        '</div>' +
      '</div>';

    carte.querySelector('[data-kqv-rejouer]').addEventListener('click', function(){
      index = 0; score = 0;
      afficherQuestion();
      recadrer();
    });
    recadrer();
  }

  /* Le haut de la carte doit rester visible quand le contenu change : on ne
     remonte que si elle est deja sortie par le haut de l'ecran. */
  function recadrer(){
    var y = carte.getBoundingClientRect().top;
    if(y < 0) window.scrollTo(0, window.pageYOffset + y - 16);
  }

  function demarrer(r){
    reglages = r || {};
    questions = (reglages.QUESTIONS || []).filter(function(q){ return q && q.a; });
    if(!questions.length) return;

    var head = root.querySelector('[data-kqv-head]');
    root.querySelector('[data-kqv-kicker]').textContent = reglages.ACCROCHE || '';
    root.querySelector('[data-kqv-titre]').textContent = reglages.TITRE || '';
    root.querySelector('[data-kqv-chapo]').textContent = reglages.CHAPO || '';
    head.hidden = !(reglages.ACCROCHE || reglages.TITRE || reglages.CHAPO);

    afficherQuestion();
  }

  if(window.KQV_REGLAGES){ demarrer(window.KQV_REGLAGES); }
  else { document.addEventListener('kqv:reglages-prets', function(){ demarrer(window.KQV_REGLAGES); }); }
})();


/* ============================================================
   REGLAGES - le seul bloc a modifier.
   ============================================================ */
window.KQV_REGLAGES = {

  /* -------- en-tete (vide : la carte se suffit a elle-meme) -------- */
  ACCROCHE: "",
  TITRE: "",
  CHAPO: "",

  /* -------- libelles -------- */
  ETIQUETTE: "Vrai ou faux",
  ETIQUETTE_FIN: "Votre r\u00e9sultat",
  VRAI: "Vrai",
  FAUX: "Faux",
  BRAVO: "Bonne r\u00e9ponse",
  RATE: "Rat\u00e9",
  CETAIT: "la r\u00e9ponse \u00e9tait",
  SUIVANT: "Question suivante",
  VOIR_RESULTAT: "Voir mon r\u00e9sultat",
  REJOUER: "Recommencer",

  /* -------- bouton facultatif de l'ecran final --------
     Mettez lien: "" pour n'afficher que " Recommencer ". */
  RDV: {
    libelle: "Prendre rendez-vous",
    lien: "https://home.shortcutssoftware.com/koehlercoiffeur#/_h/locations/info",
    nouvelOnglet: true
  },

  /* -------- les messages de fin, du meilleur au moins bon --------
     min = score a partir duquel le message s'affiche. */
  PALIERS: [
    {
      min: 27,
      titre: "Vous connaissez vos cheveux par c\u0153ur !",
      texte: "Presque rien ne vous \u00e9chappe : vous savez d\u00e9j\u00e0 distinguer une id\u00e9e re\u00e7ue d'un vrai conseil. Nos \u00e9quipes auront plaisir \u00e0 \u00e9changer avec vous."
    },
    {
      min: 21,
      titre: "Vous connaissez plut\u00f4t bien vos cheveux !",
      texte: "De solides rep\u00e8res, et quelques croyances tenaces qui tra\u00eenent encore. En rendez-vous, nous prenons toujours le temps d'expliquer ce que nous faisons et pourquoi."
    },
    {
      min: 14,
      titre: "De bonnes bases, et des id\u00e9es re\u00e7ues \u00e0 corriger.",
      texte: "Le monde du cheveu est plein de fausses \u00e9vidences, souvent r\u00e9p\u00e9t\u00e9es de bonne foi. Un diagnostic en salon vaut mieux que tous les conseils entendus ici et l\u00e0."
    },
    {
      min: 0,
      titre: "Beaucoup d'id\u00e9es re\u00e7ues \u2014 et ce n'est pas grave.",
      texte: "Personne ne na\u00eet en sachant lire un cheveu, c'est notre m\u00e9tier. Venez nous poser vos questions : la consultation est gratuite et sans engagement."
    }
  ],

  /* -------- les 30 affirmations --------
     a = l'affirmation, r = true si VRAI / false si FAUX, e = l'explication */
  QUESTIONS: [
    {
      a: "Couper les pointes fait pousser les cheveux plus vite.",
      r: false,
      e: "La pousse se fait au niveau du cuir chevelu. Couper les pointes permet surtout d'\u00e9liminer les parties ab\u00eem\u00e9es et de limiter la casse."
    },
    {
      a: "Les cheveux peuvent s'habituer \u00e0 un shampoing.",
      r: false,
      e: "Les cheveux ne d\u00e9veloppent pas de \u00ab r\u00e9sistance \u00bb au shampoing. En revanche, leurs besoins et ceux du cuir chevelu peuvent \u00e9voluer avec le temps."
    },
    {
      a: "Faire deux shampoings est toujours mieux qu'un seul.",
      r: false,
      e: "Cela d\u00e9pend notamment de la fr\u00e9quence de lavage, du cuir chevelu et des produits utilis\u00e9s."
    },
    {
      a: "L'eau tr\u00e8s chaude peut rendre les cheveux plus secs.",
      r: true,
      e: "Une eau br\u00fblante dissout davantage le film protecteur du cheveu et laisse les \u00e9cailles ouvertes. L'eau ti\u00e8de suffit, et un dernier jet plus frais aide \u00e0 refermer la fibre."
    },
    {
      a: "Une coloration peut \u00eatre r\u00e9alis\u00e9e sans ammoniaque.",
      r: true,
      e: "D'autres agents alcalins permettent d'ouvrir la fibre, comme dans la coloration INOA. L'odeur est nettement plus douce, mais il s'agit toujours d'une coloration d'oxydation."
    },
    {
      a: "Le balayage et les m\u00e8ches sont exactement la m\u00eame chose.",
      r: false,
      e: "Les m\u00e8ches se travaillent section par section, souvent sous papillotes et jusqu'\u00e0 la racine. Le balayage se pose \u00e0 main lev\u00e9e, en d\u00e9grad\u00e9, pour un effet plus fondu et une repousse plus discr\u00e8te."
    },
    {
      a: "Une patine peut neutraliser les reflets jaunes ou orang\u00e9s.",
      r: true,
      e: "C'est m\u00eame sa raison d'\u00eatre : elle d\u00e9pose des pigments qui viennent contrer le reflet ind\u00e9sirable, le violet contre le jaune, le bleu contre l'orang\u00e9."
    },
    {
      a: "Une patine \u00e9claircit fortement les cheveux.",
      r: false,
      e: "Une patine colore et neutralise, elle n'\u00e9claircit pas. Gagner en clart\u00e9 demande un \u00e9claircissement, r\u00e9alis\u00e9 en amont."
    },
    {
      a: "Les cheveux mouill\u00e9s sont plus fragiles que les cheveux secs.",
      r: true,
      e: "Mouill\u00e9e, la fibre gonfle et s'\u00e9tire beaucoup plus facilement. D\u00e9m\u00ealez sans forcer, des pointes vers les racines, avec un peigne \u00e0 dents larges."
    },
    {
      a: "Brosser ses cheveux 100 fois par jour les rend plus beaux.",
      r: false,
      e: "Une manipulation excessive peut, au contraire, favoriser la casse."
    },
    {
      a: "Le shampoing doit principalement \u00eatre choisi en fonction du cuir chevelu.",
      r: true,
      e: "Le shampoing lave d'abord le cuir chevelu ; ce sont les masques et les soins qui prennent en charge les longueurs."
    },
    {
      a: "Un masque doit forc\u00e9ment \u00eatre appliqu\u00e9 sur les racines.",
      r: false,
      e: "Le masque se pose des longueurs aux pointes, l\u00e0 o\u00f9 le cheveu est le plus ancien. Sur les racines, il alourdit sans rien apporter \u2014 sauf s'il s'agit d'un soin con\u00e7u pour le cuir chevelu."
    },
    {
      a: "On peut avoir un cuir chevelu gras et des longueurs s\u00e8ches.",
      r: true,
      e: "C'est m\u00eame tr\u00e8s fr\u00e9quent : le s\u00e9bum est produit \u00e0 la racine et n'atteint pas toujours les pointes, en particulier sur cheveux longs, boucl\u00e9s ou color\u00e9s."
    },
    {
      a: "Plus un shampoing mousse, mieux il lave.",
      r: false,
      e: "La mousse d\u00e9pend des agents moussants, pas du pouvoir lavant. Un shampoing doux mousse peu et nettoie tr\u00e8s bien."
    },
    {
      a: "Le soleil peut modifier la couleur des cheveux.",
      r: true,
      e: "Les UV d\u00e9gradent les pigments, naturels comme artificiels : le blond s'\u00e9claircit, le brun tire sur le roux, une couleur fra\u00eeche se ternit."
    },
    {
      a: "Les cheveux color\u00e9s sont plus sensibles au soleil.",
      r: true,
      e: "La fibre a d\u00e9j\u00e0 \u00e9t\u00e9 ouverte pour recevoir la couleur : les pigments s'y d\u00e9lavent plus vite au soleil, \u00e0 la mer et \u00e0 la piscine."
    },
    {
      a: "Utiliser un protecteur thermique est utile m\u00eame avec un s\u00e8che-cheveux.",
      r: true,
      e: "Un s\u00e8che-cheveux tenu de trop pr\u00e8s chauffe fortement la fibre. Le protecteur limite le choc thermique et le dess\u00e8chement, pas seulement avec un fer."
    },
    {
      a: "Un cheveu fourchu peut \u00eatre r\u00e9par\u00e9 d\u00e9finitivement gr\u00e2ce \u00e0 un soin.",
      r: false,
      e: "Certains soins peuvent am\u00e9liorer temporairement son aspect, mais une fourche d\u00e9j\u00e0 form\u00e9e ne se \u00ab ressoude \u00bb pas durablement."
    },
    {
      a: "Dormir avec les cheveux mouill\u00e9s peut les fragiliser.",
      r: true,
      e: "La fibre humide est plus souple et plus vuln\u00e9rable : une nuit de frottements contre l'oreiller favorise la casse et les frisottis."
    },
    {
      a: "Plus on laisse poser un masque longtemps, plus il est efficace.",
      r: false,
      e: "Il est pr\u00e9f\u00e9rable de respecter le temps de pose recommand\u00e9 pour le produit."
    },
    {
      a: "Arracher un cheveu blanc en fait pousser plusieurs.",
      r: false,
      e: "Chaque follicule ne donne qu'un cheveu \u00e0 la fois : en arracher un n'en fait pas na\u00eetre d'autres. R\u00e9p\u00e9t\u00e9, le geste peut en revanche ab\u00eemer la racine."
    },
    {
      a: "Les cheveux peuvent pousser l\u00e9g\u00e8rement plus vite en \u00e9t\u00e9.",
      r: true,
      e: "La vitesse de croissance peut l\u00e9g\u00e8rement varier selon les saisons."
    },
    {
      a: "Les cheveux sont principalement constitu\u00e9s de k\u00e9ratine.",
      r: true,
      e: "Cette prot\u00e9ine fibreuse forme l'essentiel du cheveu ; le reste est surtout de l'eau, des lipides et des pigments."
    },
    {
      a: "On peut naturellement avoir plusieurs textures de cheveux sur une m\u00eame t\u00eate.",
      r: true,
      e: "La forme du follicule varie d'une zone \u00e0 l'autre : il est courant d'avoir des boucles \u00e0 la nuque et des longueurs bien plus lisses sur le dessus."
    },
    {
      a: "Une coloration plus claire peut toujours \u00e9claircir une ancienne coloration fonc\u00e9e.",
      r: false,
      e: "Une coloration ne d\u00e9colore pas une autre coloration. Pour \u00e9claircir une base d\u00e9j\u00e0 color\u00e9e, il faut passer par un \u00e9claircissement ou un d\u00e9capage."
    },
    {
      a: "Un balayage blond peut n\u00e9cessiter plusieurs rendez-vous pour atteindre le r\u00e9sultat souhait\u00e9.",
      r: true,
      e: "\u00c9claircir par \u00e9tapes pr\u00e9serve la fibre. Selon la base et l'historique, deux \u00e0 trois s\u00e9ances sont souvent n\u00e9cessaires pour un blond franc."
    },
    {
      a: "Deux personnes ayant exactement la m\u00eame couleur de d\u00e9part obtiendront forc\u00e9ment le m\u00eame r\u00e9sultat avec la m\u00eame technique.",
      r: false,
      e: "L'historique des colorations, la porosit\u00e9, l'\u00e9paisseur et la part de cheveux blancs changent tout : deux bases semblables \u00e0 l'\u0153il ne r\u00e9agissent pas de la m\u00eame fa\u00e7on."
    },
    {
      a: "Le chlore peut alt\u00e9rer un blond.",
      r: true,
      e: "L'eau des piscines ternit le blond et peut lui donner un reflet verd\u00e2tre. Mouiller ses cheveux \u00e0 l'eau claire avant la baignade limite les d\u00e9g\u00e2ts."
    },
    {
      a: "Les cheveux blancs sont toujours plus \u00e9pais que les autres cheveux.",
      r: false,
      e: "Ils ne sont pas syst\u00e9matiquement plus \u00e9pais : ils sont surtout plus secs et parfois plus r\u00eaches, ce qui les rend plus rebelles au coiffage."
    },
    {
      a: "Faire une consultation avant une grosse transformation peut permettre d'\u00e9viter les mauvaises surprises.",
      r: true,
      e: "Elle permet d'\u00e9valuer l'\u00e9tat de la fibre, l'historique et la faisabilit\u00e9 : le r\u00e9sultat est annonc\u00e9 avant de commencer, pas d\u00e9couvert apr\u00e8s."
    }
  ]
};

document.dispatchEvent(new CustomEvent('kqv:reglages-prets'));


(function(){
  var root = document.getElementById('kmc-root');
  if(!root) return;

  var ICONES = {
    haut: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 15l6-6 6 6"/></svg>',
    bas: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>',
    coche: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12.6 9.5 17.5 19.5 6.5"/></svg>',
    reprise: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 1 1-2.6-5.9"/><path d="M20 4.5V10h-5.5"/></svg>'
  };

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var hote = root.querySelector('[data-kmc-jeu]');
  var R = {}, entrees = [], cases = {}, actif = 0, curseur = null, verifie = false;

  function cle(r, c){ return r + ':' + c; }

  /* ---------------- preparation des donnees ---------------- */
  function preparer(){
    cases = {};
    entrees.forEach(function(e, idx){
      e.cases = [];
      for(var i = 0; i < e.mot.length; i++){
        var r = e.dir === 'h' ? e.r : e.r + i;
        var c = e.dir === 'h' ? e.c + i : e.c;
        var k = cle(r, c);
        var cel = cases[k] || (cases[k] = { r: r, c: c, lettre: e.mot[i], num: 0 });
        cel[e.dir] = idx;          // a quel mot horizontal / vertical la case appartient
        e.cases.push(k);
      }
      var premiere = cases[e.cases[0]];
      if(!premiere.num || premiere.num > e.num) premiere.num = e.num;
    });
  }

  /* ---------------- construction ---------------- */
  function construire(){
    var lignes = R.GRILLE.lignes, colonnes = R.GRILLE.colonnes;

    var grille = '';
    for(var r = 0; r < lignes; r++){
      for(var c = 0; c < colonnes; c++){
        var cel = cases[cle(r, c)];
        if(!cel){ grille += '<div class="kmc-vide" aria-hidden="true"></div>'; continue; }
        grille +=
          '<div class="kmc-case" data-kmc-case="' + cle(r, c) + '">' +
            (cel.num ? '<span class="kmc-num">' + cel.num + '</span>' : '') +
            '<input class="kmc-lettre" type="text" maxlength="1" inputmode="text" ' +
                   'autocomplete="off" autocorrect="off" autocapitalize="characters" ' +
                   'spellcheck="false" data-kmc-input="' + cle(r, c) + '" ' +
                   'aria-label="Ligne ' + (r + 1) + ', colonne ' + (c + 1) + '">' +
          '</div>';
      }
    }

    function liste(dir, titre){
      var items = entrees.map(function(e, idx){
        if(e.dir !== dir) return '';
        return '<li><button type="button" class="kmc-indice" data-kmc-indice="' + idx + '">' +
                 '<b>' + e.num + '</b><span>' + esc(e.def) + '</span></button></li>';
      }).join('');
      return '<div class="kmc-liste"><h3>' + esc(titre) + '</h3><ol>' + items + '</ol></div>';
    }

    hote.innerHTML =
      '<div class="kmc-carte">' +
        '<div class="kmc-colonnes">' +
          '<div>' +
            '<div class="kmc-bandeau">' +
              '<div class="kmc-def">' +
                '<span class="kmc-def-tete" data-kmc-def-tete></span>' +
                '<span class="kmc-def-texte" data-kmc-def-texte></span>' +
              '</div>' +
              '<div class="kmc-nav">' +
                '<button type="button" data-kmc-prec aria-label="' +
                  esc(R.PRECEDENT || 'D\u00e9finition pr\u00e9c\u00e9dente') + '">' + ICONES.haut + '</button>' +
                '<button type="button" data-kmc-suiv aria-label="' +
                  esc(R.SUIVANT || 'D\u00e9finition suivante') + '">' + ICONES.bas + '</button>' +
              '</div>' +
            '</div>' +
            '<div class="kmc-grille-hote" style="--kmc-cols:' + colonnes + '">' +
              '<div class="kmc-grille" style="--kmc-cols:' + colonnes + '">' + grille + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="kmc-listes">' +
            liste('h', R.HORIZONTAL || 'Horizontalement') +
            liste('v', R.VERTICAL || 'Verticalement') +
          '</div>' +
        '</div>' +
        '<div class="kmc-actions">' +
          '<button type="button" class="kmc-btn kmc-btn-plein" data-kmc-verifier>' +
            ICONES.coche + esc(R.VERIFIER || 'V\u00e9rifier mes r\u00e9ponses') + '</button>' +
          '<button type="button" class="kmc-btn kmc-btn-vide" data-kmc-effacer>' +
            ICONES.reprise + esc(R.RECOMMENCER || 'Recommencer') + '</button>' +
          '<p class="kmc-bilan" data-kmc-bilan aria-live="polite"></p>' +
        '</div>' +
        '<div data-kmc-bravo></div>' +
      '</div>';

    brancher();
    selectionner(0, entrees[0].cases[0], false);
  }

  /* ---------------- evenements ---------------- */
  function brancher(){
    hote.addEventListener('click', function(e){
      var indice = e.target.closest('[data-kmc-indice]');
      if(indice){
        var idx = parseInt(indice.getAttribute('data-kmc-indice'), 10);
        selectionner(idx, debutDuMot(idx), true);
        return;
      }
      var boite = e.target.closest('[data-kmc-case]');
      if(boite) clicCase(boite.getAttribute('data-kmc-case'));
    });

    hote.querySelector('[data-kmc-prec]').addEventListener('click', function(){ decaler(-1); });
    hote.querySelector('[data-kmc-suiv]').addEventListener('click', function(){ decaler(1); });
    hote.querySelector('[data-kmc-verifier]').addEventListener('click', verifier);
    hote.querySelector('[data-kmc-effacer]').addEventListener('click', recommencer);

    [].slice.call(hote.querySelectorAll('[data-kmc-input]')).forEach(function(input){
      var k = input.getAttribute('data-kmc-input');
      input.addEventListener('focus', function(){
        clicCase(k, true);
        // La lettre deja presente est selectionnee : la frappe la remplace.
        try{ input.setSelectionRange(0, input.value.length); }catch(e){}
      });
      // maxlength = 1 : sans ce nettoyage, une case pleine refuse toute
      // nouvelle lettre et le mot semble bloque au premier croisement.
      // \u00ab beforeinput \u00bb couvre les claviers de telephone, ou keydown ne
      // renvoie souvent qu'une touche \u00ab Unidentified \u00bb.
      input.addEventListener('beforeinput', function(ev){
        if(ev.inputType === 'insertText' && input.value) input.value = '';
      });
      input.addEventListener('input', function(){ saisie(input, k); });
      input.addEventListener('keydown', function(ev){ touche(ev, input, k); });
    });
  }

  function clicCase(k, depuisFocus){
    var cel = cases[k];
    if(!cel) return;
    var idx = actif;
    var appartient = (cel.h === actif || cel.v === actif);
    if(!appartient){
      // On garde la direction en cours si la case s'y prete, sinon on bascule.
      var dirActive = entrees[actif].dir;
      idx = (cel[dirActive] != null) ? cel[dirActive]
          : (cel.h != null ? cel.h : cel.v);
    } else if(curseur === k && !depuisFocus){
      // Reclic sur la meme case : on bascule horizontal <-> vertical.
      var autre = entrees[actif].dir === 'h' ? cel.v : cel.h;
      if(autre != null) idx = autre;
    }
    selectionner(idx, k, true);
  }

  function selectionner(idx, k, focus){
    actif = idx;
    curseur = k;
    var e = entrees[idx];

    [].slice.call(hote.querySelectorAll('.kmc-case')).forEach(function(el){
      el.classList.remove('kmc-actif', 'kmc-curseur');
    });
    e.cases.forEach(function(kk){
      var el = hote.querySelector('[data-kmc-case="' + kk + '"]');
      if(el) el.classList.add('kmc-actif');
    });
    var courant = hote.querySelector('[data-kmc-case="' + k + '"]');
    if(courant) courant.classList.add('kmc-curseur');

    hote.querySelector('[data-kmc-def-tete]').textContent =
      e.num + ' \u2014 ' + (e.dir === 'h' ? (R.HORIZONTAL || 'Horizontalement')
                                     : (R.VERTICAL || 'Verticalement'));
    hote.querySelector('[data-kmc-def-texte]').textContent = e.def;

    [].slice.call(hote.querySelectorAll('[data-kmc-indice]')).forEach(function(b){
      b.classList.toggle('kmc-indice-actif',
        parseInt(b.getAttribute('data-kmc-indice'), 10) === idx);
    });

    if(focus){
      var input = hote.querySelector('[data-kmc-input="' + k + '"]');
      if(input){
        if(document.activeElement !== input) input.focus({ preventScroll: true });
        try{ input.setSelectionRange(0, input.value.length); }catch(e){}
      }
    }
  }

  // On se pose TOUJOURS sur la premiere case du mot. Viser la premiere case
  // libre paraissait malin, mais des qu'un croisement etait deja rempli le
  // curseur demarrait au milieu et le mot tape se decalait d'une lettre.
  function debutDuMot(idx){
    return entrees[idx].cases[0];
  }

  function decaler(pas){
    var idx = (actif + pas + entrees.length) % entrees.length;
    selectionner(idx, debutDuMot(idx), true);
  }

  function saisie(input, k){
    // La grille est ecrite sans accents, comme dans tout mot croise : on
    // accepte quand meme \u00ab E \u00bb frappe en \u00ab \u00c9 \u00bb ou \u00ab \u00c8 \u00bb, et on le ramene a
    // sa lettre de base. Sinon la bonne reponse serait comptee fausse.
    var v = (input.value || '').toUpperCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\u0152/g, 'OE').replace(/\u00c6/g, 'AE')
      .replace(/[^A-Z]/g, '');
    // On ne garde que la derniere lettre frappee.
    input.value = v ? v.slice(-1) : '';
    if(verifie) nettoyerMarque(k);
    if(input.value) avancer(1);
    controlerFin();
  }

  function touche(ev, input, k){
    var e = entrees[actif];
    var i = e.cases.indexOf(k);
    if(ev.key === 'Backspace'){
      if(!input.value && i > 0){
        ev.preventDefault();
        selectionner(actif, e.cases[i - 1], true);
        var prec = hote.querySelector('[data-kmc-input="' + e.cases[i - 1] + '"]');
        if(prec){ prec.value = ''; nettoyerMarque(e.cases[i - 1]); }
      } else if(input.value){
        nettoyerMarque(k);
      }
      return;
    }
    if(ev.key && ev.key.length === 1 && !ev.ctrlKey && !ev.metaKey && !ev.altKey){
      // Une seule touche imprimable : on libere la case pour la nouvelle lettre.
      if(input.value) input.value = '';
      return;
    }
    if(ev.key === 'ArrowRight' || ev.key === 'ArrowDown'){ ev.preventDefault(); avancer(1); }
    else if(ev.key === 'ArrowLeft' || ev.key === 'ArrowUp'){ ev.preventDefault(); avancer(-1); }
    else if(ev.key === 'Enter' || ev.key === 'Tab'){ ev.preventDefault(); decaler(ev.shiftKey ? -1 : 1); }
  }

  function avancer(pas){
    var e = entrees[actif];
    var i = e.cases.indexOf(curseur) + pas;
    if(i < 0 || i >= e.cases.length) return;
    selectionner(actif, e.cases[i], true);
  }

  function nettoyerMarque(k){
    var el = hote.querySelector('[data-kmc-case="' + k + '"]');
    if(el) el.classList.remove('kmc-juste', 'kmc-erreur');
  }

  /* ---------------- verification ---------------- */
  function lettreSaisie(k){
    var input = hote.querySelector('[data-kmc-input="' + k + '"]');
    return input ? (input.value || '').toUpperCase() : '';
  }

  function verifier(){
    verifie = true;
    var justes = 0, fautes = 0, vides = 0;

    Object.keys(cases).forEach(function(k){
      var el = hote.querySelector('[data-kmc-case="' + k + '"]');
      var saisi = lettreSaisie(k);
      el.classList.remove('kmc-juste', 'kmc-erreur');
      if(!saisi){ vides++; return; }
      if(saisi === cases[k].lettre){ el.classList.add('kmc-juste'); justes++; }
      else { el.classList.add('kmc-erreur'); fautes++; }
    });

    marquerMotsTrouves();

    var bilan = hote.querySelector('[data-kmc-bilan]');
    if(fautes === 0 && vides === 0){ bilan.textContent = ''; feliciter(); }
    else{
      var bouts = [justes + (justes > 1 ? ' lettres justes' : ' lettre juste')];
      if(fautes) bouts.push(fautes + (fautes > 1 ? ' \u00e0 revoir' : ' \u00e0 revoir'));
      if(vides) bouts.push(vides + (vides > 1 ? ' cases vides' : ' case vide'));
      bilan.textContent = bouts.join(' \u00b7 ');
    }
  }

  function marquerMotsTrouves(){
    entrees.forEach(function(e, idx){
      var complet = e.cases.every(function(k){ return lettreSaisie(k) === cases[k].lettre; });
      var b = hote.querySelector('[data-kmc-indice="' + idx + '"]');
      if(b) b.classList.toggle('kmc-indice-trouve', complet);
    });
  }

  function controlerFin(){
    var complet = Object.keys(cases).every(function(k){
      return lettreSaisie(k) === cases[k].lettre;
    });
    if(complet){ marquerMotsTrouves(); feliciter(); }
  }

  function feliciter(){
    var f = R.BRAVO || {};
    var bilan = hote.querySelector('[data-kmc-bilan]');
    if(bilan) bilan.textContent = '';
    var boite = hote.querySelector('[data-kmc-bravo]');
    if(boite.firstChild) return;
    boite.innerHTML =
      '<div class="kmc-bravo">' +
        '<h3 class="kmc-bravo-titre">' + esc(f.titre || 'Grille compl\u00e9t\u00e9e !') + '</h3>' +
        '<div class="kmc-bravo-filet" aria-hidden="true"></div>' +
        '<p class="kmc-bravo-texte">' + esc(f.texte || '') + '</p>' +
        '<div class="kmc-bravo-actions">' +
          '<button type="button" class="kmc-btn kmc-btn-vide" data-kmc-rejouer>' +
            ICONES.reprise + esc(R.RECOMMENCER || 'Recommencer') + '</button>' +
          (f.lien
            ? '<a class="kmc-btn kmc-btn-plein" href="' + esc(f.lien) + '"' +
              (f.nouvelOnglet ? ' target="_blank" rel="noopener"' : '') + '>' +
                esc(f.libelle || 'Prendre rendez-vous') + '</a>'
            : '') +
        '</div>' +
      '</div>';
    boite.querySelector('[data-kmc-rejouer]').addEventListener('click', recommencer);
  }

  function recommencer(){
    verifie = false;
    [].slice.call(hote.querySelectorAll('[data-kmc-input]')).forEach(function(i){ i.value = ''; });
    [].slice.call(hote.querySelectorAll('.kmc-case')).forEach(function(el){
      el.classList.remove('kmc-juste', 'kmc-erreur');
    });
    [].slice.call(hote.querySelectorAll('[data-kmc-indice]')).forEach(function(b){
      b.classList.remove('kmc-indice-trouve');
    });
    hote.querySelector('[data-kmc-bilan]').textContent = '';
    hote.querySelector('[data-kmc-bravo]').innerHTML = '';
    selectionner(0, entrees[0].cases[0], true);
  }

  /* ---------------- demarrage ---------------- */
  function demarrer(r){
    R = r || {};
    if(!R.GRILLE || !R.GRILLE.entrees || !R.GRILLE.entrees.length) return;
    entrees = R.GRILLE.entrees.map(function(e){
      return { num: e.num, dir: e.dir, r: e.r, c: e.c, mot: e.mot.toUpperCase(), def: e.def };
    });

    var head = root.querySelector('[data-kmc-head]');
    root.querySelector('[data-kmc-kicker]').textContent = R.ACCROCHE || '';
    root.querySelector('[data-kmc-titre]').textContent = R.TITRE || '';
    root.querySelector('[data-kmc-chapo]').textContent = R.CHAPO || '';
    head.hidden = !(R.ACCROCHE || R.TITRE || R.CHAPO);

    preparer();
    construire();
  }

  if(window.KMC_REGLAGES){ demarrer(window.KMC_REGLAGES); }
  else { document.addEventListener('kmc:reglages-prets', function(){ demarrer(window.KMC_REGLAGES); }); }
})();


/* ============================================================
   R\u00c9GLAGES \u2014 le seul bloc \u00e0 modifier.
   La grille (GRILLE) est \u00e9crite par injecter-grille.py : ne la
   modifiez pas \u00e0 la main, elle ne serait plus v\u00e9rifi\u00e9e.
   ============================================================ */
window.KMC_REGLAGES = {

  /* -------- en-t\u00eate (vide : la carte se suffit \u00e0 elle-m\u00eame) -------- */
  ACCROCHE: "",
  TITRE: "",
  CHAPO: "",

  /* -------- libell\u00e9s -------- */
  HORIZONTAL: "Horizontalement",
  VERTICAL: "Verticalement",
  VERIFIER: "V\u00e9rifier mes r\u00e9ponses",
  RECOMMENCER: "Recommencer",
  PRECEDENT: "D\u00e9finition pr\u00e9c\u00e9dente",
  SUIVANT: "D\u00e9finition suivante",

  /* -------- message de fin -------- */
  BRAVO: {
    titre: "Grille compl\u00e9t\u00e9e, bravo !",
    texte: "Vous parlez cheveux couramment. Il ne vous reste plus qu'\u00e0 venir en salon pour la pratique.",
    libelle: "Prendre rendez-vous",
    lien: "https://home.shortcutssoftware.com/koehlercoiffeur#/_h/locations/info",
    nouvelOnglet: true
  },

  /* -------- LA GRILLE \u2014 g\u00e9n\u00e9r\u00e9e, ne pas \u00e9diter \u00e0 la main -------- */
  GRILLE: /* @GRILLE@ */ {
    lignes: 12,
    colonnes: 12,
    entrees: [
      { num: 2, dir: "h", r: 0, c: 5, mot: "BLOND", def: "Il demande souvent plusieurs rendez-vous." },
      { num: 5, dir: "h", r: 3, c: 3, mot: "SHAMPOING", def: "Il lave d'abord le cuir chevelu." },
      { num: 6, dir: "h", r: 5, c: 2, mot: "KERATINE", def: "La prot\u00e9ine dont le cheveu est principalement fait." },
      { num: 8, dir: "h", r: 7, c: 4, mot: "MECHES", def: "\u00c9claircies section par section, sous papillotes." },
      { num: 10, dir: "h", r: 9, c: 0, mot: "SALON", def: "Le lieu du rendez-vous." },
      { num: 11, dir: "h", r: 10, c: 6, mot: "RACINE", def: "L\u00e0 o\u00f9 le cheveu commence." },
      { num: 12, dir: "h", r: 11, c: 1, mot: "FRANGE", def: "Elle habille le front." },
      { num: 1, dir: "v", r: 0, c: 3, mot: "TRESSE", def: "Trois m\u00e8ches entrelac\u00e9es." },
      { num: 2, dir: "v", r: 0, c: 5, mot: "BALAYAGE", def: "\u00c9claircissement travaill\u00e9 \u00e0 main lev\u00e9e, pour un effet fondu." },
      { num: 3, dir: "v", r: 0, c: 11, mot: "CHIGNON", def: "Coiffure relev\u00e9e, reine des jours de mariage." },
      { num: 4, dir: "v", r: 2, c: 8, mot: "POINTES", def: "Les extr\u00e9mit\u00e9s que l'on rafra\u00eechit." },
      { num: 6, dir: "v", r: 5, c: 2, mot: "KOEHLER", def: "Notre nom, sur la porte du salon." },
      { num: 7, dir: "v", r: 6, c: 0, mot: "GLOSS", def: "Il ravive la couleur et fait briller." },
      { num: 9, dir: "v", r: 7, c: 6, mot: "CARRE", def: "Coupe nette, souvent au niveau de la m\u00e2choire." },
    ]
  }
};

document.dispatchEvent(new CustomEvent('kmc:reglages-prets'));


(function(){
  var root = document.getElementById('kmm-root');
  if(!root) return;

  var ICONES = {
    coche: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12.6 9.5 17.5 19.5 6.5"/></svg>',
    reprise: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 1 1-2.6-5.9"/><path d="M20 4.5V10h-5.5"/></svg>'
  };

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var hote = root.querySelector('[data-kmm-jeu]');
  var R = {}, lignes = [], mots = [], taille = 0;
  var grilleEl, depart = null, encours = [], armee = null, trouves = 0;

  var DIRECTIONS = [[0,1],[0,-1],[1,0],[-1,0],[1,1],[1,-1],[-1,1],[-1,-1]];

  function cle(r, c){ return r + ':' + c; }
  function caseEl(r, c){ return grilleEl.querySelector('[data-kmm-case="' + cle(r, c) + '"]'); }

  /* ---------------- construction ---------------- */
  function construire(){
    var cases = '';
    for(var r = 0; r < taille; r++){
      for(var c = 0; c < taille; c++){
        cases += '<div class="kmm-case" data-kmm-case="' + cle(r, c) + '">' +
                   lignes[r][c] + '</div>';
      }
    }

    var liste = mots.map(function(m, i){
      return '<span class="kmm-mot" data-kmm-mot="' + i + '">' + ICONES.coche +
             '<span>' + esc(m.mot) + '</span></span>';
    }).join('');

    hote.innerHTML =
      '<div class="kmm-carte">' +
        '<div class="kmm-tete">' +
          '<p class="kmm-consigne">' + esc(R.CONSIGNE || '') + '</p>' +
          '<span class="kmm-compteur" data-kmm-compteur></span>' +
        '</div>' +
        '<div class="kmm-grille-hote" style="--kmm-cols:' + taille + '">' +
          '<div class="kmm-grille" style="--kmm-cols:' + taille + '" data-kmm-grille>' + cases + '</div>' +
        '</div>' +
        '<div class="kmm-mots">' + liste + '</div>' +
        '<div class="kmm-actions">' +
          '<button type="button" class="kmm-btn kmm-btn-vide" data-kmm-rejouer>' +
            ICONES.reprise + esc(R.RECOMMENCER || 'Recommencer') + '</button>' +
        '</div>' +
        '<div data-kmm-bravo></div>' +
      '</div>';

    grilleEl = hote.querySelector('[data-kmm-grille]');
    majCompteur();
    brancher();
  }

  function majCompteur(){
    var el = hote.querySelector('[data-kmm-compteur]');
    el.textContent = trouves + ' / ' + mots.length + ' ' +
      (R.MOTS_TROUVES || 'mots trouv\u00e9s');
  }

  /* ---------------- selection ---------------- */
  function caseSous(x, y){
    var el = document.elementFromPoint(x, y);
    if(!el) return null;
    var boite = el.closest ? el.closest('[data-kmm-case]') : null;
    if(!boite || !grilleEl.contains(boite)) return null;
    var p = boite.getAttribute('data-kmm-case').split(':');
    return { r: parseInt(p[0], 10), c: parseInt(p[1], 10) };
  }

  function aligner(a, b){
    /* Le doigt suit rarement une droite parfaite : on projette sa position
       sur la direction la plus proche, comme le ferait un aimant. */
    var dr = b.r - a.r, dc = b.c - a.c;
    if(dr === 0 && dc === 0) return [a];
    var meilleur = null;
    DIRECTIONS.forEach(function(d){
      var score = dr * d[0] + dc * d[1];
      if(score <= 0) return;
      var longueur = Math.round(Math.max(Math.abs(dr), Math.abs(dc)));
      if(d[0] !== 0 && d[1] !== 0) longueur = Math.round((Math.abs(dr) + Math.abs(dc)) / 2);
      var ecart = Math.abs(dr - d[0] * longueur) + Math.abs(dc - d[1] * longueur);
      if(!meilleur || score - ecart > meilleur.score - meilleur.ecart){
        meilleur = { d: d, longueur: longueur, score: score, ecart: ecart };
      }
    });
    if(!meilleur) return [a];

    var suite = [];
    for(var i = 0; i <= meilleur.longueur; i++){
      var rr = a.r + i * meilleur.d[0], cc = a.c + i * meilleur.d[1];
      if(rr < 0 || cc < 0 || rr >= taille || cc >= taille) break;
      suite.push({ r: rr, c: cc });
    }
    return suite;
  }

  function peindre(suite){
    [].slice.call(grilleEl.querySelectorAll('.kmm-sel')).forEach(function(el){
      el.classList.remove('kmm-sel');
    });
    suite.forEach(function(p){
      var el = caseEl(p.r, p.c);
      if(el) el.classList.add('kmm-sel');
    });
    encours = suite;
  }

  function effacerSelection(){
    [].slice.call(grilleEl.querySelectorAll('.kmm-sel')).forEach(function(el){
      el.classList.remove('kmm-sel');
    });
    encours = [];
  }

  function valider(suite){
    if(suite.length < 2) return false;
    var a = suite[0], b = suite[suite.length - 1];
    for(var i = 0; i < mots.length; i++){
      var m = mots[i];
      if(m.trouve) continue;
      var finR = m.r + (m.mot.length - 1) * m.dr;
      var finC = m.c + (m.mot.length - 1) * m.dc;
      var memeSens = (a.r === m.r && a.c === m.c && b.r === finR && b.c === finC);
      var inverse  = (b.r === m.r && b.c === m.c && a.r === finR && a.c === finC);
      if(memeSens || inverse){
        marquerTrouve(i, suite);
        return true;
      }
    }
    return false;
  }

  function marquerTrouve(i, suite){
    var m = mots[i];
    m.trouve = true;
    trouves++;
    suite.forEach(function(p){
      var el = caseEl(p.r, p.c);
      if(el) el.classList.add('kmm-trouve');
    });
    var etiquette = hote.querySelector('[data-kmm-mot="' + i + '"]');
    if(etiquette) etiquette.classList.add('kmm-mot-trouve');
    majCompteur();
    if(trouves === mots.length) feliciter();
  }

  function refuser(suite){
    suite.forEach(function(p){
      var el = caseEl(p.r, p.c);
      if(el) el.classList.add('kmm-refus');
    });
    setTimeout(function(){
      suite.forEach(function(p){
        var el = caseEl(p.r, p.c);
        if(el) el.classList.remove('kmm-refus');
      });
    }, 260);
  }

  /* ---------------- evenements ---------------- */
  function brancher(){
    grilleEl.addEventListener('pointerdown', function(ev){
      var p = caseSous(ev.clientX, ev.clientY);
      if(!p) return;
      ev.preventDefault();
      if(armee){
        // Deuxieme tape : on ferme la selection commencee au doigt precedent.
        var suite = aligner(armee, p);
        if(!valider(suite)) refuser(suite);
        effacerSelection();
        armee = null;
        return;
      }
      depart = p;
      peindre([p]);
      try{ grilleEl.setPointerCapture(ev.pointerId); }catch(e){}
    });

    grilleEl.addEventListener('pointermove', function(ev){
      if(!depart) return;
      var p = caseSous(ev.clientX, ev.clientY);
      if(!p) return;
      peindre(aligner(depart, p));
    });

    function relacher(ev){
      if(!depart) return;
      var p = caseSous(ev.clientX, ev.clientY) || depart;
      var suite = aligner(depart, p);
      if(suite.length < 2){
        // Simple tape : on garde la case en attente d'une deuxieme tape.
        // C'est le mode le plus sur sur telephone, sans glisser.
        armee = depart;
        peindre([depart]);
      } else {
        if(!valider(suite)) refuser(suite);
        effacerSelection();
        armee = null;
      }
      depart = null;
    }
    grilleEl.addEventListener('pointerup', relacher);
    grilleEl.addEventListener('pointercancel', function(){
      depart = null; effacerSelection();
    });

    hote.querySelector('[data-kmm-rejouer]').addEventListener('click', recommencer);
  }

  /* ---------------- fin ---------------- */
  function feliciter(){
    var f = R.BRAVO || {};
    var boite = hote.querySelector('[data-kmm-bravo]');
    if(boite.firstChild) return;
    boite.innerHTML =
      '<div class="kmm-bravo">' +
        '<h3 class="kmm-bravo-titre">' + esc(f.titre || 'Tous les mots trouv\u00e9s !') + '</h3>' +
        '<div class="kmm-bravo-filet" aria-hidden="true"></div>' +
        '<p class="kmm-bravo-texte">' + esc(f.texte || '') + '</p>' +
        '<div class="kmm-bravo-actions">' +
          '<button type="button" class="kmm-btn kmm-btn-vide" data-kmm-rejouer2>' +
            ICONES.reprise + esc(R.RECOMMENCER || 'Recommencer') + '</button>' +
          (f.lien
            ? '<a class="kmm-btn kmm-btn-plein" href="' + esc(f.lien) + '"' +
              (f.nouvelOnglet ? ' target="_blank" rel="noopener"' : '') + '>' +
                esc(f.libelle || 'Prendre rendez-vous') + '</a>'
            : '') +
        '</div>' +
      '</div>';
    boite.querySelector('[data-kmm-rejouer2]').addEventListener('click', recommencer);
  }

  function recommencer(){
    trouves = 0;
    armee = null; depart = null;
    mots.forEach(function(m){ m.trouve = false; });
    [].slice.call(grilleEl.querySelectorAll('.kmm-case')).forEach(function(el){
      el.classList.remove('kmm-trouve', 'kmm-sel', 'kmm-refus');
    });
    [].slice.call(hote.querySelectorAll('[data-kmm-mot]')).forEach(function(el){
      el.classList.remove('kmm-mot-trouve');
    });
    hote.querySelector('[data-kmm-bravo]').innerHTML = '';
    majCompteur();
  }

  /* ---------------- demarrage ---------------- */
  function demarrer(r){
    R = r || {};
    if(!R.GRILLE || !R.GRILLE.lignes || !R.GRILLE.lignes.length) return;
    taille = R.GRILLE.taille;
    lignes = R.GRILLE.lignes;
    mots = R.GRILLE.mots.map(function(m){
      return { mot: m.mot, r: m.r, c: m.c, dr: m.dr, dc: m.dc, trouve: false };
    });

    var head = root.querySelector('[data-kmm-head]');
    root.querySelector('[data-kmm-kicker]').textContent = R.ACCROCHE || '';
    root.querySelector('[data-kmm-titre]').textContent = R.TITRE || '';
    root.querySelector('[data-kmm-chapo]').textContent = R.CHAPO || '';
    head.hidden = !(R.ACCROCHE || R.TITRE || R.CHAPO);

    construire();
  }

  if(window.KMM_REGLAGES){ demarrer(window.KMM_REGLAGES); }
  else { document.addEventListener('kmm:reglages-prets', function(){ demarrer(window.KMM_REGLAGES); }); }
})();


/* ============================================================
   REGLAGES - le seul bloc a modifier.
   GRILLE est ecrite par injecter-grille.py : ne pas la retoucher
   a la main, elle ne serait plus verifiee.
   ============================================================ */
window.KMM_REGLAGES = {

  ACCROCHE: "",
  TITRE: "",
  CHAPO: "",

  CONSIGNE: "Glissez le doigt sur un mot, ou touchez sa premi\u00e8re puis sa derni\u00e8re lettre. Les mots se cachent dans tous les sens, diagonales comprises.",
  MOTS_TROUVES: "mots trouv\u00e9s",
  RECOMMENCER: "Recommencer",

  BRAVO: {
    titre: "Seize mots, seize trouv\u00e9s !",
    texte: "Vous avez l'\u0153il. Le m\u00eame, en salon, s'appelle un diagnostic.",
    libelle: "Prendre rendez-vous",
    lien: "https://home.shortcutssoftware.com/koehlercoiffeur#/_h/locations/info",
    nouvelOnglet: true
  },

  GRILLE: /* @GRILLE@ */ {
    taille: 12,
    lignes: [
      "BOUCLEFMTCAD",
      "NGIGNIHSURBF",
      "BRCOIFFAGERA",
      "RIEDARGEDSTL",
      "OOSDEZNMUVDP",
      "SHFFESUEDNOT",
      "SCLILMAQVBNC",
      "EEPEIGNEARUU",
      "TSTREECOPZQI",
      "NLOSIUIEEDUV",
      "TINCISEAUXER",
      "RCUOMBRERMZE",
    ],
    mots: [
      { mot: "BOUCLE", r: 0, c: 0, dr: 0, dc: 1 },
      { mot: "BROSSE", r: 2, c: 0, dr: 1, dc: 0 },
      { mot: "BRUSHING", r: 1, c: 10, dr: 0, dc: -1 },
      { mot: "CISEAUX", r: 10, c: 3, dr: 0, dc: 1 },
      { mot: "COIFFAGE", r: 2, c: 2, dr: 0, dc: 1 },
      { mot: "CUIVRE", r: 6, c: 11, dr: 1, dc: 0 },
      { mot: "DEGRADE", r: 3, c: 8, dr: 0, dc: -1 },
      { mot: "MIROIR", r: 6, c: 5, dr: 1, dc: -1 },
      { mot: "NUANCIER", r: 4, c: 6, dr: 1, dc: 0 },
      { mot: "NUQUE", r: 6, c: 10, dr: 1, dc: 0 },
      { mot: "OMBRE", r: 11, c: 3, dr: 0, dc: 1 },
      { mot: "PEIGNE", r: 7, c: 2, dr: 0, dc: 1 },
      { mot: "REFLET", r: 3, c: 5, dr: 1, dc: -1 },
      { mot: "SECHOIR", r: 8, c: 1, dr: -1, dc: 0 },
      { mot: "TONDEUSE", r: 5, c: 11, dr: 0, dc: -1 },
      { mot: "VAPEUR", r: 6, c: 8, dr: 1, dc: 0 },
    ]
  }
};

document.dispatchEvent(new CustomEvent('kmm:reglages-prets'));
